import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { TechnicianServiceType } from 'types';

type getAssignableTechnicianServiceTypesParams = {
  technicianId?: string;
};

export const getAssignableTechnicianServiceTypes = async ({
  queryKey,
}: QueryFunctionContext<[string, getAssignableTechnicianServiceTypesParams]>): Promise<TechnicianServiceType[]> => {
  const [, params] = queryKey;
  const { data } = await baseQuery(`technicians/${params.technicianId}/service-types/available`);

  return data as TechnicianServiceType[];
};
